import * as Yup from 'yup';

export const ServiceUsageOriginSchema = Yup.object().shape({
  missionTypeId: Yup.string().required('Type de mission requis'),
  serviceUsageId: Yup.string().required('Prestation requise'),
});
